export default __webpack_public_path__ + "static/media/Arrow-45-money.6dc23076.svg";